import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SpinnerDriver extends BaseUniDriver {}

export const spinnerDriverFactory = (base: UniDriver): SpinnerDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
